<template>
<!--    <v-row-->
<!--            justify="center"-->
<!--    >-->
        <v-card
                class="ma-3 pa-2"
                height="300"
                width="225"
                color="#fafafa"
        >
            <v-card-title class="title">
                <div class="mx-auto">
                    {{ $t('heading.stack') }}
                </div>
            </v-card-title>
            <v-card-subtitle>
                <div class="subtitle text-center">
                    {{ title }}
                </div>
            </v-card-subtitle>
            <v-card-text class="text">
                <div>
                    {{ text }}
                </div>
<!--                <div>-->
<!--                    {{ count }} {{ $t('heading.cards') }}-->
<!--                </div>-->
            </v-card-text>
            <v-card-actions
                    class="actions"
            >
                <v-btn
                        class="mx-auto"
                        :color="yellow"
                        @click="onClick()"
                >
                    {{ buttonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
<!--    </v-row>-->
</template>

<script>
    import basic from "@/components/mixins/basic";
    import StackMixin from "@/components/mixins/StackMixin";
    import {arabic2hindi} from "@/lib/funclib";

    export default {
        name: "StackDrillCard",
        mixins: [basic, StackMixin],
        props: {
            title: {
                type: String,
                required: true
            },
            text: {
                type: String,
                required: true
            },
            count: {
                type: Number,
                required: true
            }
        },
        data () {
            return {

            }
        },
        methods: {
            onClick () {
                this.$emit('clicked')
            }
        },
        computed: {
            buttonText () {
                return this.$t('nav.drill') + ' ' + arabic2hindi(this.count) + ' ' + this.$t('heading.cards');
            },
        }
    }
</script>

<style scoped>
    .title {
        /*background-color: #42b983;*/
    }
    .subtitle {
        /*background-color: aqua;*/
        color: black;
        font-size: 120%
    }
    .text {
        /*background-color: aquamarine;*/
        height: 140px;
    }
    .actions {
        /*background-color: burlywood;*/
    }
</style>